(function () {
  'use strict';
  var cfg = window.CosySleeps || {};

  // Sticky header shadow
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  // Mobile announcement expander
  var bar = document.querySelector('[data-announcement]');
  var barToggle = document.querySelector('[data-announcement-toggle]');
  if (bar && barToggle) {
    barToggle.addEventListener('click', function () {
      var open = bar.classList.toggle('is-open');
      barToggle.setAttribute('aria-expanded', open);
    });
  }

  // Copy discount code
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-copy');
      var done = function () { btn.classList.add('is-copied'); setTimeout(function () { btn.classList.remove('is-copied'); }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });
  });

  // Mobile menu drawer
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  if (drawer && openBtn) {
    var setDrawer = function (open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', !open);
      openBtn.setAttribute('aria-expanded', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var c = drawer.querySelector('.drawer__close'); if (c) c.focus(); } else { openBtn.focus(); }
    };
    openBtn.addEventListener('click', function () { setDrawer(true); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setDrawer(false); });
  }

  // Buy now: set the book to exactly 1 copy in the cart, then go straight to checkout
  document.querySelectorAll('[data-buy-now]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      var id = form.querySelector('input[name="id"]').value;
      var updates = {}; updates[id] = 1;
      var checkout = cfg.checkoutUrl || '/checkout';
      if (cfg.discountCode) checkout = '/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=' + encodeURIComponent(checkout);
      fetch(cfg.cartUpdateUrl || '/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = checkout;
      }).catch(function () { form.submit(); });
    });
  });

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === i); });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  });

  // Sticky buy bar: show once the main buy button scrolls out of view
  var sticky = document.querySelector('[data-sticky-atc]');
  var buyBox = document.querySelector('#BuyBox .buy-form');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var finalCta = document.querySelector('.final-cta');
    var past = false, nearEnd = false;
    var update = function () {
      var show = past && !nearEnd;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', !show);
      sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    };
    new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }).observe(buyBox);
    if (finalCta) new IntersectionObserver(function (en) { nearEnd = en[0].isIntersecting; update(); }).observe(finalCta);
  }

  // Gentle reveal on scroll
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
